import { ChakraEmptyList } from 'app/components/Core';
import { FolderItem } from 'types/song';
import { ReactComponent as SongIcon } from 'resources/images/song.svg';

interface SongEmptyListProps {
  folder?: FolderItem;
  onNewSong?: () => void;
  isDisabled?: boolean;
}

export const SongEmptyList = ({ folder }: SongEmptyListProps) => {
  if (folder) {
    return (
      <ChakraEmptyList
        title="No Songs Yet"
        primaryText="Organise your songs into folders for easy access."
      />
    );
  }

  return (
    <ChakraEmptyList
      icon={<SongIcon role="img" />}
      title="Your one-stop shop for creative collaboration and storing files"
      primaryText="The best place to organise your song ideas and recordings, and invite fellow creators to capture who did what, where and when."
      secondaryText="Stay creative!"
    />
  );
};
